// @flow

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getEntries } from '../../../helpers';
import TitleComponent from '../../title';
import type { PdbPrices } from '../../../store/pdbComparison';
import type { TechSpecs as TechSpecsType } from '../../../store/pdbComparison/types';
import { Price } from '../atoms';
import type { Theme } from '../../../types';

import {
  Cell,
  TitleCell,
  Table,
  Row,
  ResponsiveRow,
  ResponsiveCell,
} from '../../table';

const Title = styled<typeof TitleComponent, Theme, _>(TitleComponent)`
  margin-bottom: 1.75rem;
`;

type Props = {|
  specs: TechSpecsType,
  prices: PdbPrices,
  heading: string,
  orderLabel: string,
  moreInfoLabel: string,
  priceLabel: string,
|};

// @TODO remove static strings from this component and add link to the different pages
// https://justlease.atlassian.net/secure/RapidBoard.jspa?rapidView=74&modal=detail&selectedIssue=JUS-908
const TechSpecs = ({
  specs,
  prices,
  heading,
  orderLabel,
  moreInfoLabel,
  priceLabel,
}: Props) => (
  <>
    <Title>{heading}</Title>
    <Table>
      <tbody>
        {getEntries(specs).map(([key, values]) => (
          <Fragment key={key}>
            <ResponsiveRow>
              <TitleCell colSpan={values.length + 1}>{key}</TitleCell>
            </ResponsiveRow>
            <Row>
              <ResponsiveCell>{key}</ResponsiveCell>
              {values.map((value, index) => (
                <Cell key={index}>{value}</Cell> // eslint-disable-line react/no-array-index-key
              ))}
            </Row>
          </Fragment>
        ))}
        <ResponsiveRow>
          <TitleCell colSpan={prices.length + 1}>{priceLabel}</TitleCell>
        </ResponsiveRow>
        <Row>
          <ResponsiveCell>{priceLabel}</ResponsiveCell>
          {prices.map(({ pdbId, price }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Cell key={index}>
              <Price
                price={price}
                pdbId={pdbId}
                orderLabel={orderLabel}
                moreInfoLabel={moreInfoLabel}
              />
            </Cell>
          ))}
        </Row>
      </tbody>
    </Table>
  </>
);

export default TechSpecs;
